import "./Dress.css"
import Product1 from "../Components/Product1"

import Dress1 from "../images/d1.jpg"
import Dress2 from "../images/d2.jpg"
import Dress3 from "../images/d3.jpg"
import Dress4 from "../images/d4.jpg"
import Dress5 from "../images/d5.jpg"
import Dress6 from "../images/d6.jpg"
import Dress7 from "../images/d7.jpg"
import Dress8 from "../images/d8.jpg"
import Dress9 from "../images/womenadd.jpg"

export default function Dress() {

  return (
    <div className="stdivinhome">
      <div className="add"><img src={Dress9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="dress1" prdName="Dell i5" img={Dress1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="dress2" prdName="Dell i7" img={Dress2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>      

          </div>

          <div className="home__prd1">

          
          <Product1 id="dress3"  prdName="Hp i7" img={Dress3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="dress4" prdName="Hp i5" img={Dress4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="dress5" prdName="Mack book " img={Dress5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="dress6" prdName="Mackbook 2" img={Dress6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="dress7" prdName="Mack book pro" img={Dress7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="dress8" prdName="Mack book pro" img={Dress8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}